import type { Group, Mesh, SceneControl } from '@anov/3d-core'
import ObjectLayer from '../../Base/ObjectLayer'

export const StrategyManage = {
  pyramid: async () => (await import('./Pyramid')).default,
  cylinder: async () => (await import('./Cylinder')).default,
}

export default class LinkMesh extends ObjectLayer {
  _readyPromise: Promise<boolean>
  _vspace: [number, number] = [0, 0] // 垂直间距
  _hspace: [number, number] = [0, 0] // 水平间距
  _mesh: Group | Mesh
  _listeners = new Set()

  constructor(sceneControl: SceneControl) {
    super(sceneControl)
  }

  public get ready() {
    return this._readyPromise
  }

  public get vspace() {
    return this._vspace
  }

  public set vspace(newValue) {
    this._vspace = newValue
  }

  public get hspace() {
    return this._hspace
  }

  public get mesh() {
    return this._mesh
  }

  public setupAnimation() {}

  // 注册监听
  public addReloadListener(callback) {
    this._listeners.add(callback)
  }

  // 移除监听
  public removeReloadListener(callback) {
    this._listeners.delete(callback)
  }

  // 销毁
  public destroy() {
    this._mesh.remove()
    this._mesh.removeFromParent()
    this._listeners.clear()
  }
}